export const defaultAvatarUrl = 'https://d10u3i9rmggm8w.cloudfront.net/defaults/default_user_image.jpg';

/**
 * Build an SEO meta description for use in generateMetadata (server-side safe).
 * Strips HTML with a regex (no DOM), collapses whitespace and truncates to ~160
 * chars at a word boundary so Bing/Google don't truncate mid-word in SERPs.
 */
export const buildMetaDescription = (text, maxLength = 160) => {
  const plain = String(text || '')
    .replace(/<[^>]*>?/gm, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (plain.length <= maxLength) return plain;
  const slice = plain.slice(0, maxLength - 1);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > maxLength * 0.5 ? slice.slice(0, lastSpace) : slice;
  return `${cut.replace(/[\s.,;:–-]+$/, '')}…`;
};

/**
 * Keep document titles inside the practical SERP limit. Root layouts append
 * " | Ágora", so callers normally use the 52-character default here.
 */
export const buildMetaTitle = (text, maxLength = 52) => {
  const plain = String(text || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (plain.length <= maxLength) return plain;
  const slice = plain.slice(0, maxLength - 1);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > maxLength * 0.55 ? slice.slice(0, lastSpace) : slice;
  return `${cut.replace(/[\s|·,;:–-]+$/, '')}…`;
};
